import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { TResponse } from "../../../types/common";
import { ICountry, IState, ICity } from "../../../types/api/location";

export async function fetchCountries(params?: { search?: string; limit?: number }): Promise<AxiosResponse<TResponse<ICountry[]>>> {
  return axios.get(API_ENDPOINTS.LOCATION_COUNTRIES, { params });
}

export async function fetchStates(
  country_id: number,
  params?: { search?: string; limit?: number }
): Promise<AxiosResponse<TResponse<IState[]>>> {
  return axios.get(API_ENDPOINTS.LOCATION_STATES, { params: { country_id, ...params } });
}

export async function fetchCities(
  state_id: number,
  params?: { search?: string; limit?: number }
): Promise<AxiosResponse<TResponse<ICity[]>>> {
  return axios.get(API_ENDPOINTS.LOCATION_CITIES, { params: { state_id, ...params } });
}
